<template>
  <v-app id="app">
    <!-- Driver Interface Layout -->
    <driver-layout v-if="isDriverRoute" />
    
    <!-- Main Application Layout -->
    <template v-else>
      <nav-bar v-if="isLandingPage" />
      <authenticated-nav v-if="isAuthenticatedUser()" />
      <admin-nav v-else-if="isAuthenticatedAdmin()" />
      <v-main :class="isLandingPage ? 'pa-0 ma-0' : ''">
        <snack-bar ref="snackBar" />
        <router-view />
        <app-footer v-if="isLandingPage" />
      </v-main>
    </template>
  </v-app>
</template>

<script>
  import AuthenticatedNav from '@/components/authenticated/navigation/AuthenticatedNav.vue';
  import SnackBar from '@/components/shared/SnackBar.vue';
  import AdminNav from '@/components/admin/AdminNav.vue';
  import AppFooter from '@/components/footer/AppFooter.vue';
  import NavBar from '@/components/navigation/NavBar.vue';
  import DriverLayout from '@/views/driver/DriverLayout.vue';
  import { useAuthentication } from '@/composables/useAuthentication';
  import { setupAxiosInterceptors } from '@/services/axiosInterceptor';

  export default {
    name: 'App',

    components: {
      NavBar,
      AppFooter,
      AdminNav,
      AuthenticatedNav,
      SnackBar,
      DriverLayout,
    },

    data() {
      const auth = useAuthentication();
      return {
        isAuthenticatedUser: auth.isAuthenticatedUser,
        isAuthenticatedAdmin: auth.isAuthenticatedAdmin,
      };
    },

    computed: {
      isLandingPage() {
        return this.$route.name === 'landing';
      },
      isDriverRoute() {
        return this.$route.path.startsWith('/driver');
      },
    },

    mounted() {
      this.initializeApp();
    },

    methods: {
      initializeApp() {
        this.$root.snackBar = this.$refs.snackBar;
        setupAxiosInterceptors();
      },
    },
  };
</script>

<style lang="scss">
  @import './styles/_app.scss';
  @import './styles/_typography.scss';
  @import './styles/_colors.scss';

  html {
    overflow-y: auto !important;
  }
</style>
